module.exports = __webpack_public_path__ + "static/media/typewriter.bbcb1fce.svg";